import { Search, ShoppingCart } from 'lucide-react'

export type PosMobilePanel = 'products' | 'cart'

interface PosMobileTabsProps {
  activePanel: PosMobilePanel
  cartQuantity: number
  onPanelChange: (panel: PosMobilePanel) => void
  onPriceCheck: () => void
}

export function PosMobileTabs({
  activePanel,
  cartQuantity,
  onPanelChange,
  onPriceCheck,
}: PosMobileTabsProps) {
  return (
    <div
      role="tablist"
      aria-label="Secciones del punto de venta"
      className="mb-3 grid grid-cols-[minmax(0,1fr)_minmax(0,1fr)_auto] gap-2 lg:hidden"
    >
      <button
        id="pos-products-tab"
        type="button"
        role="tab"
        aria-selected={activePanel === 'products'}
        aria-controls="pos-products-panel"
        onClick={() => onPanelChange('products')}
        className={`rounded-lg border px-3 py-2 text-sm font-medium ${activePanel === 'products'
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-slate-200 bg-white text-slate-700'}`}
      >
        Productos
      </button>
      <button
        id="pos-cart-tab"
        type="button"
        role="tab"
        aria-selected={activePanel === 'cart'}
        aria-controls="pos-cart-panel"
        onClick={() => onPanelChange('cart')}
        className={`flex items-center justify-center gap-2 rounded-lg border px-3 py-2 text-sm font-medium ${activePanel === 'cart'
          ? 'border-primary bg-primary text-primary-foreground'
          : 'border-slate-200 bg-white text-slate-700'}`}
      >
        <ShoppingCart className="h-4 w-4" />
        Carrito
        <span className={`rounded-full px-1.5 py-0.5 text-[11px] ${activePanel === 'cart' ? 'bg-white/20' : 'bg-primary/10 text-primary'}`}>
          {cartQuantity}
        </span>
      </button>
      <button
        type="button"
        onClick={onPriceCheck}
        className="inline-flex items-center justify-center gap-2 rounded-lg border border-primary/30 bg-white px-3 py-2 text-sm font-medium text-primary"
        aria-label="Abrir consulta rápida"
        title="Consulta rápida"
      >
        <Search className="h-4 w-4" />
        <span className="hidden sm:inline">Consulta rápida</span>
      </button>
    </div>
  )
}
